// extracted by mini-css-extract-plugin
export default {"container":"style_container__IjNuE","title":"style_title__nEmz+","divider":"style_divider__NJc2g","children":"style_children__Z7QBr","formFooter":"style_formFooter__Tckh3"};